export interface ISpinParams {
  autoSpin: boolean;
  fastSpin: boolean;
  skipPopups?: boolean;
}

export class SlotSpinParams implements ISpinParams {
  autoSpin: boolean = false;
  fastSpin: boolean = false;
  skipPopups: boolean = false;
}
